"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
var core_1 = require("@emotion/core");
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var View_1 = require("../View");
var icons_1 = require("../icons");
var theme_1 = require("../theme");
var DISMISS_TIME = 5000; // 5 seconds
var CTAButton = styled_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: transparent;\n  border-radius: ", ";\n  border: 0;\n  color: ", ";\n  cursor: pointer;\n  height: ", ";\n  margin: 0 ", ";\n  padding: 0 ", ";\n  white-space: nowrap;\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"], ["\n  background: transparent;\n  border-radius: ", ";\n  border: 0;\n  color: ", ";\n  cursor: pointer;\n  height: ", ";\n  margin: 0 ", ";\n  padding: 0 ", ";\n  white-space: nowrap;\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"])), theme_1.theme.space.space4, theme_1.theme.colors.blue300, theme_1.theme.space.space24, theme_1.theme.space.space12, theme_1.theme.space.space16, theme_1.theme.colors.n600, theme_1.theme.colors.blue200);
var CloseButton = styled_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: transparent;\n  border-radius: ", ";\n  border: 0;\n  cursor: pointer;\n  height: ", ";\n  margin-left: auto;\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  background: transparent;\n  border-radius: ", ";\n  border: 0;\n  cursor: pointer;\n  height: ", ";\n  margin-left: auto;\n  &:hover {\n    background: ", ";\n  }\n"])), theme_1.theme.space.space4, theme_1.theme.space.space24, theme_1.theme.colors.n600);
var Content = styled_1.default.div(function (_a) {
    var icon = _a.icon;
    if (icon) {
        return "\n      column-gap: ".concat(theme_1.theme.space.space12, ";\n      display: grid;\n      grid-template-columns: max-content 1fr;\n  ");
    }
    return "\n    display: flex;\n  ";
});
var IconWrapper = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-self: baseline;\n"], ["\n  align-self: baseline;\n"])));
var ChildrenWrapper = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  align-self: center;\n"], ["\n  align-self: center;\n"])));
var ToastView = (0, styled_1.default)(View_1.View)(function (_a) {
    var hasCta = _a.hasCta;
    return (0, core_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    background-color: ", ";\n    border-radius: ", ";\n    color: ", ";\n    display: grid;\n    grid-template-columns: ", ";\n    padding: ", " ", ";\n\n    position: fixed;\n\n    bottom: ", ";\n    right: ", ";\n    width: calc(100% - ", ");\n    min-width: unset;\n\n    @media (min-width: ", ") {\n      bottom: ", ";\n      right: ", ";\n      width: unset;\n      min-width: 440px;\n      max-width: min(640px, calc(100% - ", "));\n    }\n  "], ["\n    background-color: ", ";\n    border-radius: ", ";\n    color: ", ";\n    display: grid;\n    grid-template-columns: ", ";\n    padding: ", " ", ";\n\n    position: fixed;\n\n    bottom: ", ";\n    right: ", ";\n    width: calc(100% - ", ");\n    min-width: unset;\n\n    @media (min-width: ", ") {\n      bottom: ", ";\n      right: ", ";\n      width: unset;\n      min-width: 440px;\n      max-width: min(640px, calc(100% - ", "));\n    }\n  "])), theme_1.theme.colors.bgOverlayInverse, theme_1.theme.radii.field, theme_1.theme.colors.contentInverse, hasCta
        ? 'auto min-content min-content'
        : 'auto min-content', theme_1.theme.space.space16, theme_1.theme.space.space12, theme_1.theme.space.space8, theme_1.theme.space.space8, theme_1.theme.space.space16, theme_1.theme.mediaQueries.small, theme_1.theme.space.space24, theme_1.theme.space.space24, theme_1.theme.space.space48);
});
/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use the new Toast component instead.
 * See [the new Toast documentation](https://compass.circleci.com/?path=/story/rac-toast--default) for examples of the new Toast implementation.
 */
var Toast = function (_a) {
    var _b = _a.autoDismiss, autoDismiss = _b === void 0 ? true : _b, children = _a.children, cta = _a.cta, icon = _a.icon, onClose = _a.onClose, _c = _a.timeOutInSeconds, timeOutInSeconds = _c === void 0 ? DISMISS_TIME : _c, props = __rest(_a, ["autoDismiss", "children", "cta", "icon", "onClose", "timeOutInSeconds"]);
    var _d = (0, react_1.useState)(true), isVisible = _d[0], setIsVisible = _d[1];
    var dismissToast = (0, react_1.useCallback)(function () {
        setIsVisible(false);
        if (onClose) {
            onClose();
        }
        return;
    }, [onClose]);
    (0, react_1.useEffect)(function () {
        if (!autoDismiss)
            return;
        var timer = setTimeout(dismissToast, timeOutInSeconds);
        return function () { return clearTimeout(timer); };
    }, [autoDismiss, dismissToast, timeOutInSeconds]);
    if (!isVisible)
        return null;
    return (react_1.default.createElement(ToastView, __assign({ role: "status", hasCta: !!cta }, props),
        react_1.default.createElement(Content, { icon: !!icon },
            react_1.default.createElement(IconWrapper, null, icon),
            react_1.default.createElement(ChildrenWrapper, null, children)),
        cta ? react_1.default.createElement(CTAButton, { onClick: cta.onClick }, cta.text) : null,
        react_1.default.createElement(CloseButton, { onClick: dismissToast, "aria-label": "close toast" },
            react_1.default.createElement(icons_1.CancelIcon, { color: "contentInverse" }))));
};
exports.Toast = Toast;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Toast.js.map